// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as IssueForm from "../form-sections/IssueForm.bs.js";
import * as ActionForm from "../form-sections/ActionForm.bs.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as BasicInfoForm from "../form-sections/BasicInfoForm.bs.js";
import * as ProgressModal from "../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as RaiseTicketDataMachine from "../../../app/repo/RaiseTicketDataMachine.bs.js";
import * as RaiseTicketSuccessPage from "../RaiseTicketSuccessPage.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function RaiseTicketAgentDeskCmp(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  React.useEffect((function () {
          var order_stage = state.selected_basic_info.order_stage;
          if (order_stage !== undefined) {
            var match = state.current_view;
            if (match !== 0) {
              switch (match) {
                case /* IssueForm */1 :
                    var match$1 = state.issues;
                    var exit = 0;
                    if (typeof match$1 === "number") {
                      exit = 1;
                    } else {
                      switch (match$1.TAG | 0) {
                        case /* Loading */0 :
                        case /* Live */1 :
                            break;
                        case /* Error */2 :
                            exit = 1;
                            break;
                        
                      }
                    }
                    if (exit === 1) {
                      RaiseTicketDataMachine.fetchTicketIssues(order_stage, country, (function (issues) {
                              return Curry._1(dispatch, {
                                          TAG: /* SetAvailableIssues */1,
                                          issues: {
                                            TAG: /* Live */1,
                                            _0: issues
                                          }
                                        });
                            }), (function (error) {
                              return Curry._1(dispatch, {
                                          TAG: /* SetTicketInfo */0,
                                          ticket_info: {
                                            TAG: /* Error */2,
                                            _0: error
                                          }
                                        });
                            }));
                    }
                    break;
                case /* ActionForm */2 :
                    var match$2 = state.actions;
                    var exit$1 = 0;
                    if (typeof match$2 === "number") {
                      exit$1 = 1;
                    } else {
                      switch (match$2.TAG | 0) {
                        case /* Loading */0 :
                        case /* Live */1 :
                            break;
                        case /* Error */2 :
                            exit$1 = 1;
                            break;
                        
                      }
                    }
                    if (exit$1 === 1) {
                      RaiseTicketDataMachine.fetchTicketActions(order_stage, country, (function (actions) {
                              return Curry._1(dispatch, {
                                          TAG: /* SetAvailableActions */2,
                                          actions: {
                                            TAG: /* Live */1,
                                            _0: actions
                                          }
                                        });
                            }), (function (error) {
                              return Curry._1(dispatch, {
                                          TAG: /* SetAvailableActions */2,
                                          actions: {
                                            TAG: /* Error */2,
                                            _0: error
                                          }
                                        });
                            }));
                    }
                    break;
                case /* SuccessPage */3 :
                    break;
                
              }
            }
            
          }
          
        }), [state.current_view]);
  var match$1 = state.create_ticket_response;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Loading */0 ? null : React.createElement(ProgressModal.make, {
          isOpen: true
        });
  var match$2 = state.current_view;
  var tmp$1;
  switch (match$2) {
    case /* BasicInfoForm */0 :
        var _data = state.ticket_info;
        if (typeof _data === "number") {
          tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
        } else {
          switch (_data.TAG | 0) {
            case /* Loading */0 :
                tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
                break;
            case /* Live */1 :
                tmp$1 = React.createElement(BasicInfoForm.make, {
                      form_data: state.selected_basic_info,
                      dispatch: dispatch
                    });
                break;
            case /* Error */2 :
                tmp$1 = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: _data._0
                    });
                break;
            
          }
        }
        break;
    case /* IssueForm */1 :
        var data = state.issues;
        if (typeof data === "number") {
          tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
        } else {
          switch (data.TAG | 0) {
            case /* Loading */0 :
                tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
                break;
            case /* Live */1 :
                tmp$1 = React.createElement(IssueForm.make, {
                      issue_form_data: state.issue_form_data,
                      issues: data._0,
                      dispatch: dispatch
                    });
                break;
            case /* Error */2 :
                tmp$1 = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: data._0
                    });
                break;
            
          }
        }
        break;
    case /* ActionForm */2 :
        var data$1 = state.actions;
        if (typeof data$1 === "number") {
          tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
        } else {
          switch (data$1.TAG | 0) {
            case /* Loading */0 :
                tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
                break;
            case /* Live */1 :
                tmp$1 = React.createElement(ActionForm.make, {
                      state: state,
                      actions: data$1._0,
                      dispatch: dispatch
                    });
                break;
            case /* Error */2 :
                tmp$1 = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: data$1._0
                    });
                break;
            
          }
        }
        break;
    case /* SuccessPage */3 :
        var ticket_response = state.create_ticket_response;
        if (typeof ticket_response === "number") {
          tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
        } else {
          switch (ticket_response.TAG | 0) {
            case /* Loading */0 :
                tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
                break;
            case /* Live */1 :
                EventTracker.publishEvent({
                      category: "Raise Ticket (using AgentDesk)",
                      action: "Raise Ticket from Agent desk Success",
                      label: "Random",
                      value: undefined,
                      nonInteraction: undefined
                    });
                tmp$1 = React.createElement(RaiseTicketSuccessPage.make, {
                      ticket_response: ticket_response._0
                    });
                break;
            case /* Error */2 :
                EventTracker.publishEvent({
                      category: "Raise Ticket (using AgentDesk)",
                      action: "Raise Ticket from Agent desk Failure",
                      label: "Random",
                      value: undefined,
                      nonInteraction: undefined
                    });
                tmp$1 = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                      error: ticket_response._0
                    });
                break;
            
          }
        }
        break;
    
  }
  return React.createElement("div", {
              className: "c-raise-ticket-home"
            }, tmp, tmp$1);
}

var make = RaiseTicketAgentDeskCmp;

export {
  make ,
  
}
/* react Not a pure module */
